import { addBreadcrumb, setTags } from '@sentry/capacitor';

export class ErrorWithBreadcrumb extends Error {
  category: BreadCrumbCategoryEnum;
  override message: string;
  userName: string | null = null;
  siteName: string | null = null;
  override cause?: unknown;

  constructor({
    category,
    message,
    cause,
    userName = null,
    siteName = null
  }: {
    category: BreadCrumbCategoryEnum;
    message: string;
    userName?: string | null;
    siteName?: string | null;
    cause?: unknown;
  }) {
    super();
    this.category = category;
    this.message = message;
    this.userName = userName;
    this.siteName = siteName;
    this.cause = cause;
    addBreadcrumb({
      category: this.category,
      message: this.message,
      level: 'error'
    });
    setTags({
      ...(this.userName && { userName: this.userName.toLowerCase() }),
      ...(this.siteName && { siteName: normalizeSiteName(this.siteName) })
    });
  }
}

export class TypeErrorWithBreadcrumb extends TypeError {
  category: BreadCrumbCategoryEnum;
  override message: string;
  userName: string | null = null;
  siteName: string | null = null;
  override cause?: unknown;

  constructor({
    category,
    message,
    cause,
    userName = null,
    siteName = null
  }: {
    category: BreadCrumbCategoryEnum;
    message: string;
    userName?: string | null;
    siteName?: string | null;
    cause?: unknown;
  }) {
    super();
    this.category = category;
    this.message = message;
    this.userName = userName;
    this.siteName = siteName;
    this.cause = cause;
    addBreadcrumb({
      category: this.category,
      message: this.message,
      level: 'error'
    });
    setTags({
      ...(this.userName && { userName: this.userName.toLowerCase() }),
      ...(this.siteName && { siteName: normalizeSiteName(this.siteName) })
    });
  }
}

export function updateSentryTags(userName: string, siteName: string): void {
  setTags({
    userName: userName.toLowerCase(),
    siteName: normalizeSiteName(siteName)
  });
}

function normalizeSiteName(siteName: string) {
  const lowerCaseSiteName = siteName.toLowerCase();
  const suffix = '.e-komplet.dk';

  if (lowerCaseSiteName.endsWith(suffix)) {
    return lowerCaseSiteName.slice(0, lowerCaseSiteName.length - suffix.length);
  }

  return lowerCaseSiteName;
}